import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as CoreActions from '../../core/actions/coreActions';
import { UI_STATES, SURVEY_JOB_TYPE } from '../../core/constants/coreConstants';
import Tenant from '../../util/tenant';
import { VERSION } from '../../configurations';

class Shell extends Component {
    render() {
        return (
            <div>
                <nav className="navbar navbar-default navbar-fixed-top">
					<div className="container">
						<div className="brand" />
					</div>
				</nav>

				{this.props.children}

                <div className="container">
					<footer>
						<div className="text-center">
							<span className="bambora-brand-text">Powered By</span>
							<span className="bambora-brand" />
							<span className="client-brand" />
                            {this.props.core.serviceDeskContactNumber ? ( 
                                <p className="contact">
                                    If you need assistance contact us on <a href={"tel:" + this.props.core.serviceDeskContactNumber}>{this.props.core.serviceDeskContactNumber}</a>
                                </p>
                            ) : null}
							<p>Version : {VERSION}</p>
						</div>
					</footer>
				</div>
            </div>
        );
	}
	
	componentDidMount() {
		this.props.coreActions.getContactNumber(Tenant.getName());
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.core.uiState != nextProps.core.uiState && nextProps.core.uiState == UI_STATES.SURVEY)
			this.props.coreActions.getContactNumber(Tenant.getName(), SURVEY_JOB_TYPE);
	}
}

function mapStateToProps(state) {
	return {
		core: state.core
	};
}

function mapDispatchToProps(dispatch) {
	return {
        coreActions: bindActionCreators(CoreActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Shell);


// WEBPACK FOOTER //
// ./app/core/containers/shell.js